<template>
  <div class="page">
    <div class="top">
      <div>
        <div class="icon"><i class="fa-solid fa-cube"></i></div>
        <div class="title"><span>Wireds</span></div>
      </div>
      <div class="actions">
        <div>
          <i class="fa-solid fa-magnifying-glass"></i>
          <input type="text" name="search" v-model="search" @keyup.enter="getWired(1, search)" minlength="1"
                 placeholder="Pesquisar o wired...">
        </div>
        <button :disabled="prev === 0" @click="getWired(cat, '', prev)"><i class="fa-solid fa-angle-left"></i></button>
        <button :disabled="next >= total" @click="getWired(cat, '', next)"><i class="fa-solid fa-angle-right"></i>
        </button>
      </div>
    </div>
    <div class="cats">
      <div class="back">
        <div class="title">Clique no wired para<br>acessar o tutorial</div>
        <div class="cat">
          <button :class="{'active': cat === 0}" @click="() => {getWired(0); cat = 0}">Todos</button>
          <button :class="{'active': cat === 1}" @click="() => {getWired(1); cat = 1}">Efeitos</button>
          <button :class="{'active': cat === 2}" @click="() => {getWired(2); cat = 2}">Condiçôes</button>
          <button :class="{'active': cat === 3}" @click="() => {getWired(3); cat = 3}">Ativadores</button>
          <button :class="{'active': cat === 4}" @click="() => {getWired(4); cat = 4}">Seletores</button>
          <button :class="{'active': cat === 5}" @click="() => {getWired(5); cat = 5}">Tutoriais</button>
        </div>
      </div>
    </div>
    <div class="content">
      <template v-if="loading">
        <div class="box" v-for="i in 12" :key="i" style="pointer-events:none">
          <div class="line" style="background-color:#e2e8f0"></div>
          <Sk w="48px" h="48px" rounded="rounded-lg" extra="mb-2" />
          <Sk w="80%" h="13px" extra="mb-1.5" />
          <Sk w="100%" h="10px" />
          <Sk w="90%" h="10px" extra="mt-1" />
        </div>
      </template>
      <div class="box" v-else v-for="(w, i) in wireds" :key="i" @click="() => {modO = w; modW = true}">
        <div class="line"
             :class="{'efeit': w.cat_id == 1, 'cond': w.cat_id == 2, 'ativ': w.cat_id == 3, 'sel': w.cat_id == 4, 'tuto': w.cat_id == 5}"></div>
        <div class="icon" :style="{backgroundImage: 'url('+w.icon+')'}"></div>
        <div class="title nobr">{{ w.wired }}</div>
        <div class="desc">{{ w.description }}</div>
      </div>
    </div>
    <Transition name="slide-fade">
      <ModWired v-if="modW" :obj="modO" @close="modW = false" />
    </Transition>
  </div>
</template>

<script setup>
import { getWireds } from '@/services/api.js'
import { trackEvent } from '@/services/analytics.js'
import ModWired from '@/components/modals/modWired.vue'
import Sk from '@/components/usefulness/Sk.vue'
import { ref } from 'vue'

const wireds = ref([])
const loading = ref(true)
const search = ref('')
const cat = ref(0)
const prev = ref(0)
const next = ref(0)
const total = ref(0)
const modO = ref([])
const modW = ref(false)

async function getWired(c, s = '', p = 1) {
  loading.value = true
  const se = s === '' ? search.value : s
  const data = await getWireds({ cat: c, search: se, pag: p })
  wireds.value = data.wireds
  prev.value   = data.prev
  next.value   = data.next
  total.value  = data.total
  loading.value = false
}

getWired(cat.value)
trackEvent('wired_view')

</script>

<style scoped>

.top {
  display: flex;
  justify-content: space-between;
}

.top .icon {
  background-image: none;
  background-color: #37758D;
}

.page .top .actions {
  position: relative;
  width: 40%;
  display: flex;
  justify-content: space-around;
}

.page .top .actions div > i {
  position: absolute;
  margin: 12px 0 0 14px;
  font-size: 13px;
}

.page .top .actions div > input {
  float: left;
  width: 220px;
  height: 36px;
  background-color: #fff;
  border-radius: 20px;
  padding-left: 36px;
}

.top .actions button {
  float: left;
  width: 36px;
  height: 36px;
  border-radius: 30px;
  background-color: #D7DDE4;
  font-size: 14px;
  text-align: center;
  line-height: 36px;
  color: #BDC4CD;
}

.page .cats {
  width: 100%;
  height: 150px;
  background-image: url('@/assets/back-wired.png');
  background-size: cover;
  margin-top: 14px;
  border-radius: 12px;
}

.page .cats .back {
  position: relative;
  width: 100%;
  height: 100%;
  background: rgb(13, 147, 198);
  background: linear-gradient(180deg, rgba(13, 147, 198, 0) 0%, rgba(13, 147, 198, 1) 100%);
  border-radius: 12px;
}

.page .cats .back .title {
  float: left;
  width: 100%;
  height: 80px;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  line-height: 20px;
  color: #fff;
  text-shadow: 0 3px 6px rgba(0, 0, 0, .5);
  margin-top: 20px;
}

.page .cats .back .cat {
  position: relative;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  margin-top: 20px;
}

.page .cats .back .cat button {
  width: auto;
  height: 26px;
  background-color: #fff;
  border-radius: 12px;
  font-weight: 600;
  padding: 0 16px;
  transition: all .3s ease;
  cursor: pointer;
}

.page .cats .back .cat button.active,
.page .cats .back .cat button:hover {
  background-color: #2EC044;
  color: #fff;
}

.page .content {
  background-color: transparent;
  box-shadow: none;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.page .content .box {
  position: relative;
  width: calc(25% - 10px);
  height: auto;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .15);
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.page .content .box .line {
  position: absolute;
  top: 0;
  left: 50%;
  width: 60px;
  height: 4px;
  border-radius: 0 0 4px 4px;
  transform: translateX(-50%);
}

.page .content .box .line.cond {
  background-color: #0D93C6;
}

.page .content .box .line.efeit {
  background-color: #2FC145;
}

.page .content .box .line.ativ {
  background-color: #e45bcd;
}

.page .content .box .line.sel {
  background-color: #e93c11;
}

.page .content .box .line.tuto {
  background-color: #e6e337;
}

.page .content .box .icon {
  width: 100%;
  height: 50px;
  background-position: center;
  background-repeat: no-repeat;
}

.page .content .box .title {
  width: 100%;
  height: auto;
  line-height: 20px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  margin: 4px 0;
}

.page .content .box .desc {
  width: 100%;
  height: auto;
  font-size: 12px;
  font-weight: 300;
  text-align: center;
}

@media only screen and (max-width: 500px) {
  .page .content .box {
    width: calc(50% - 10px);
  }

  .page .cats .back .title {
    height: 46px;
  }

  .page .cats .cat {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 0 !important;
  }

  .page .cats .back .cat button {
    width: 30%;
    margin-top: 4px;
  }
}
</style>
